<!--数据报表-->
<template>
  <div v-show="isShow"  :style="domStyle">
    <div class="hisHeader" ref="hisReport" id="historyReport">
      <Table
        stripe
        size="small"
        :height="tableHeight"
        :loading="loading"
        :columns="columns"
        :data="historyFormData"
        ref="historyTable"
      ></Table>
      <Page
        id="page"
        show-sizer
        :total="dataCount"
        :page-size="pageSize"
        :page-size-opts="arrOpts"
        size="small"
        class="paging"
        @on-change="changepage"
        @on-page-size-change="changepageSize"
        :current="currentPage"
      ></Page>
    </div>
    <div v-if="isEnable" :style="enableStyle"></div>
    <Icon
      type="ios-settings"
      v-show="setup"
      size="20"
      class="setting"
      @click="addPoint"
    />
    <i-circle
      :percent="progressNumber"
      v-show="isProgress"
      :size="25"
      :stroke-width="10"
      class="setting"
    >
      <span class="demo-Circle-inner" @click="offLoad">
        <Icon type="ios-close" size="25" style="color: #ff5500"></Icon>
      </span>
    </i-circle>
  </div>
</template>
<style>
.ivu-spin-fix {
  background-color: hsla(0, 0%, 100%, 0.6);
}
</style>

<style scoped>
.paging {
  float: right;
  margin-top: 5px;
  white-space: nowrap;
  display: flex;
}
.setting {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.hisHeader {
  --fontColor: #515a6e;
  --oddColor: #fff;
  --evenColor: #f8f8f9;
  --thColor: #f8f8f9;
  --bgColor: #f8f8f9;
  --borderColor: #000;
  --tableTextColor: #000;
  --trHeight:25px;
}

#historyReport >>> .ivu-table {
  color: var(--fontColor);
}

#historyReport >>> .ivu-table td {
  background-color: var(--oddColor);
}

#historyReport >>> .ivu-table-stripe .ivu-table-body tr:nth-child(2n) td {
  background-color: var(--evenColor);
}

#historyReport >>> .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
  background-color: var(--evenColor);
}

#historyReport >>> .ivu-table th {
  background-color: var(--thColor);
  /*color: var(--tableTextColor);*/
}

#historyReport >>> .ivu-table {
  background-color: var(--bgColor);
}

#historyReport >>> .ivu-page-next {
  background-color: var(--bgColor);
}

#historyReport >>> .ivu-page-prev {
  background-color: var(--bgColor);
}

#historyReport >>> .ivu-page-item {
  background-color: var(--bgColor);
}

#historyReport >>> .ivu-table:after {
  background-color: transparent;
}

#historyReport >>> .ivu-table:before {
  background-color: transparent;
}

/* 边框为其进行隐藏 */
#historyReport >>> .ivu-table-wrapper {
  border: none;
}

#historyReport >>> .ivu-table th {
  border: none;
}

#historyReport >>> .ivu-table td {
  border-color: var(--borderColor);
}
#historyReport >>> tr {
  height: var( --trHeight)
}
#historyReport >>> .ivu-table-row {
  position:relative;
}
.borderWidth{
  border-bottom: 1px dashed #e8eaec;
}
</style>
<script>
import Print from "print-js";
import { resolve } from "url";
import Vue from "vue";
import { locale, Page } from "view-design";
import cn from "view-design/dist/locale/zh-CN";
import en from "view-design/dist/locale/en-US";
Vue.component("Page", Page);
export default {
  name: "",
  props: ["primitives", "fvSystemApi", "parentObject"],
  created() {
    this.changeLange();
    this.defaultTailoring = this.parentObject.defaultTailoring;
    this.windowSize = this.parentObject.windowSize;
    //组件数据混淆
    this.mixin(this.primitives);
    //组件大小位置初始化
    this.domStyle = {
      position: "absolute",
      left: this.x + "px",
      top: this.y + "px",
      width: this.width + "px",
      height: this.height + "px",
    };
    this.enableStyle = {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0px",
      backgroundColor: "#ccbfbf",
      opacity: "0.5",
      zIndex: 1,
    };
    this.modelsPath = this.parentObject.modelsPath.slice(0);
    this.modelsPath.push(this.registerName);
    this.$store.registerModule(this.modelsPath, {
      state: {
        $: this,
      },
    });
    //获取数据
    this.UpdataData();
    //监听移出后标记置回
    document.onmouseup = function (e) {
        this.downKey=false;
        var move=document.getElementsByClassName('move');
        for(var a =0;a<move.length;a++){
          move[a].style.display="block";
        }
        if(this.toElement){
          if(parseFloat(this.toElement.style.top)<0){
            this.toElement.style.top = "0px";
          }else{
            this.toElement.style.top = this.top+this.prentY+"px";
          }
          this.domNode.toElement.style.borderBottomWidth="0px";
        }
    }.bind(this);
  },
  mounted() {
    this.func();
    
  },
  watch: {
    historyFormData: {
      handler(val, oldVal) {
        var n = 0;
        this.isTransparent ? (n = 0.2) : (n = 1);
        this.$refs.hisReport.style.setProperty(
          "--oddColor",
          this.historyFormData.length != 0
            ? this.colorRgba(this.oddColor, n)
            : this.colorRgba("#f8f8f9", n)
        );
        //字体颜色
        this.$refs.hisReport.style.setProperty("--fontColor", this.fontColor);
        //偶数
        this.$refs.hisReport.style.setProperty(
          "--evenColor",
          this.colorRgba(this.evenColor, n)
        );
        //背景色
        this.$refs.hisReport.style.setProperty(
          "--thColor",
          this.colorRgba(this.tableBackgroundColor, n)
        );
        //字体颜色
        // this.$refs.hisReport.style.setProperty("--tableTextColor",textColor);
        //是否开启透明色
        this.$refs.hisReport.style.setProperty(
          "--bgColor",
          this.isTransparent ? "transparent" : "#f8f8f9"
        );
        // this.borderColor = "#f10909"
        this.$refs.hisReport.style.setProperty(
          "--borderColor",
          this.borderColor
        );
      },
      deep: true,
    },
  },
  data() {
    return {
      isProgress: false,
      setup: false,
      progressNumber: 0,
      //是否可用
      isEnable: false,
      //是否显示
      isShow: true,
      //组件大小位置,在created(创建完毕，挂载前)函数中初始化
      domStyle: {},
      // test
      columns: [],
      historyFormData: [],
      pageSize: 5, // 后期用户手动配置，目前写死rowNumber
      dataCount: 0, // 总条数
      currentPage: 1, // 当前页数
      loading: false,
      tableHeight: 0,
      tableColWidth: 200,
      // 版本号
      version: "10.0.3.1",
     arrOpts:[10,20,40,60,80,100]//设置每页显示多少条
    };
  },
  methods: {
    changeLange() {
      if (this.$store.state.system.$.languageName == "ch") {
        locale(cn);
      } else {
        locale(en);
      }
    },
    offLoad() {
      this.dataList = [];

      this.$Notice.warning({
        title:
          this.$store.state.system.$.languageName == "ch" ? "警告" : "warning",
        desc: false
          ? ""
          : this.$store.state.system.$.languageName == "ch"
          ? "终止继续请求,请求数据未完成,如需完整数据请重新查询数据! "
          : "Stop continuing the request, the request data is not completed, if you need complete data, please re-query data!",
      });
      this.isProgress = false;
      this.setup = true;
    },
    /*
          参数：无
          作用：系统周期调用
      */
    onTimer() {
      if (this.isEnable) return;
    },
    /*
          参数：src ：外部属性（对象）
          作用：混淆属性
      */
    mixin(src) {
      for (var key in src) {
        this[key] = src[key];
      }
    },
    /*
          参数：scaleObj 重绘信息
          作用：组件需要重绘时触发
      */
    reDraw(scaleObj) {
      if (this.fontSize) {
        this.domStyle.fontSize =
          parseInt(
            parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) *
              (scaleObj.sy + scaleObj.zoom) +
              scaleObj.oy
          ) + "px";
      }
      this.domStyle.left =
        parseInt(this.x * (scaleObj.sx + scaleObj.zoom) + scaleObj.ox) + "px";
      this.domStyle.top =
        parseInt(this.y * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) +
        scaleObj.titleHeight +
        "px";
      this.domStyle.width =
        parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
      this.domStyle.height =
        parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
      this.realWidth = parseInt(this.width * (scaleObj.sx + scaleObj.zoom));
      this.tableHeight =
        parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) - 40;
      this.setColumnsData();
      this.isShow = false;
      this.$nextTick(() => {
        this.isShow = true;
        this.changeLange();
      });
    },
    /*
          参数：isShow 显示隐藏
          作用：设置组件整体显隐
      */
    Show(isShow) {
      this.isShow = isShow ? true : false;
    },
    /*
          参数：isEnable 是否可用
          作用：设置组件是否可用
      */
    Enable(isEnable) {
      this.isEnable = isEnable ? false : true;
    },
    /*
          参数： name 点名称  desc 备注名称
          作用： 添加点
      */
    AddData(name, desc) {
      if (this.page.data != null) {
        if (this.page.data.name.indexOf(name) == -1) {
          this.page.data.name.push(name);
          this.page.data.desc.push(desc);
          this.newNameList.push(name);
        }
      } else {
        this.page.data = {
          desc: [desc],
          name: [name],
        };
      }
      //this.UpdataData();
    },
    /*
          参数：无
          作用：清除所有数据
      */
    ClearData() {
      if (this.page.data != null) {
        this.page.data.name.splice(0, this.page.data.name.length);
        this.page.data.desc.splice(0, this.page.data.desc.length);
      }
      this.jsonData = null;
    },
    /*
          参数：name 要被删除的点名称
          作用：删除点
      */
    DelData(name) {
      if (this.page.data != null) {
        for (var i = 0; i < this.page.data.name.length; i++) {
          if (this.page.data.name[i] === name) {
            this.page.data.name.splice(i, 1);
            this.page.data.desc.splice(i, 1);
            //this.UpdataData();
            return;
          }
        }
      }
    },
    /*
          参数：value 更改的值
          作用：更改请求时间
      */
    SetStartTime(value) {
      this.page.startTime = value;
    },
    /*
          参数：value 更改的值
          作用：更改截止时间
      */
    SetEndTime(value) {
      this.page.endTime = value;
    },
    /*
          参数：value 更改的值
          作用：更改时间间隔
      */
    SetIntervaltime(value) {
      this.page.intervalTime = value;
    },
    /*
          参数：value 增加值的类型   num 0 为删除 1 为添加
          作用：更改所选择的计算结果
      */
    SetStatisticStyle(value, num) {
      if (this.page.statisticStyle != null) {
        if (num == 0) {
          for (var i = 0; i < this.page.statisticStyle.length; i++) {
            if (this.page.statisticStyle[i] === value) {
              this.page.statisticStyle.splice(i, 1);
            }
          }
        } else {
          if (this.page.statisticStyle.indexOf(value) == -1) {
            this.page.statisticStyle.push(value);
          }
        }
      } else {
        if (num == 1) {
          this.page.statisticStyle = [value];
        }
      }
      //this.UpdataData();
    },
    /*
          参数：value 0隐藏 1显示
          作用：是否展示时间列
      */
    SetDisplayTime(value) {
      if (value == 0) {
        this.page.displayTime = false;
      } else if (value == 1) {
        this.page.displayTime = true;
      } else {
        this.$Message.error("请传入正确的参数!");
      }
      //this.UpdataData();
    },
    /*
          参数：无
          作用：获取点列表从而对表单数据进行添加
      */
    addPoint() {
      this.showTagSelectDialog().then((req) => {
        if (req) {
          // 通过选中的点进行数据添加
          this.AddData(req.name, req.desc);
          this.UpdataData();
        }
      });
    },
    /*
          参数：无
          作用：获取点列表数据
      */
    async showTagSelectDialog() {
      var tagName;
      await this.fvSystemApi
        .selectTagsShow("Test.测试1.tag1.PV", true, true, true)
        .then(function (name) {
          tagName = name;
        });
      return tagName;
    },
    /*
          参数：无
          作用：更新数据
      */
    UpdataData() {
      //无原始，固定值改为0  为趋势历史
      // this.dataType = 0;
      //更新数据修改回默认
      this.currentPage = 1;
      // 数据加载loading
      if (this.loading) {
        // this.$Message.error("数据未请求结束");
        return;
      }
      this.loading = true;
      this.conversionData(this.page.data);
      //存储 数据列表
      this.dataList = [];
      //清空临时数据
      this.setTemporaryData = [];
      var dataStartTime = new Date(this.page.startTime).getTime();
      var dataEndeTime = new Date(this.page.endTime).getTime();
      //计算点数 （结束时间 - 开始时间） / 时间间隔 * 多少pv点
      var point =
        ((dataEndeTime - dataStartTime) / (this.page.intervalTime * 1000)) *
        this.newNameList.length;
      //用于计算时间次数与分批的计算时间差
      var endList =
        (dataEndeTime - dataStartTime) / (this.page.intervalTime * 1000);
      //如果总条数大于10000
      if (point > 10000) {
        //一条数据的个数 把时间分为多少段
        var list = Math.ceil(
          (((dataEndeTime / 1000 - dataStartTime / 1000) /
            this.page.intervalTime) *
            this.newNameList.length) /
            10000
        );
        //遍历出 需要请求的报文数组
        for (var i = 0; i < list; i++) {
          if (i == 0) {
            var data = {
              head: "dataLayer",
              message: {
                head: "getHisData",
                varList: this.newNameList,
                startTime: dataStartTime,
                endTime:
                  dataStartTime +
                  parseInt((dataEndeTime - dataStartTime) / list),
                hisType: this.dataType,
                hisStep: this.page.intervalTime,
              },
            };
          } else {
            if (
              this.dataList[i - 1].message.endTime +
                parseInt((dataEndeTime - dataStartTime) / list) >
              dataEndeTime
            ) {
              var data = {
                head: "dataLayer",
                message: {
                  head: "getHisData",
                  varList: this.newNameList,
                  startTime: this.dataList[i - 1].message.endTime,
                  endTime: endTime,
                  hisType: this.dataType,
                  hisStep: this.page.intervalTime,
                },
              };
            } else {
              var data = {
                head: "dataLayer",
                message: {
                  head: "getHisData",
                  varList: this.newNameList,
                  startTime: this.dataList[i - 1].message.endTime,
                  endTime:
                    this.dataList[i - 1].message.endTime +
                    parseInt((dataEndeTime - dataStartTime) / list),
                  hisType: this.dataType,
                  hisStep: this.page.intervalTime,
                },
              };
            }
          }
          this.dataList.push(data);
        }
      } else {
        var data = {
          head: "dataLayer",
          message: {
            head: "getHisData",
            varList: this.newNameList,
            startTime: dataStartTime,
            endTime: dataEndeTime,
            hisType: this.dataType,
            hisStep: this.page.intervalTime,
          },
        };
        this.dataList.push(data);
      }
      // 防止以后有异步事件处理，这里使用Promise.all
      Promise.all([this.conversionData(this.page.data)]).then(async () => {
        if (this.newNameList.length == 0) {
			this.historyFormData = [];
			this.columns = [];
			this.loading = false;
        } else {
			this.isProgress = true;
			this.setup = false;
			var percentage = 100 / this.dataList.length;
			for (var i = 0; i < this.dataList.length; i++) {
			await this.fvSystemApi.getHistory(this.dataList[i]).then((response) => {
				//请求回来更新进度环百分比
				this.progressNumber = percentage * (i + 1);
				// 缓存请求回来的值
				this.cacheData = JSON.parse(JSON.stringify(response));
				this.setColumnsData();
				this.setHistoryFormData(response);
				this.loading = false;
        setTimeout(()=>{
						//this.dblclickrow();
					},2000)
        
			}).catch((error) => {
				if(error.error == "获取历史请求较多，请等待"){
					setTimeout(()=>{
						this.getHistorydata(data,i);
					},1000)
				}else{
					this.$Message.error("数据请求错误！");
					this.loading = false;
				}
			});
			}
			this.isProgress = false;
			this.setup = true;
        }
      });
    },
	async getHistorydata(data,i){
		var percentage = 100 / this.dataList.length;
		await this.fvSystemApi.getHistory(data).then((response) => {
			//请求回来更新进度环百分比
			this.progressNumber = percentage * (i + 1);
			// 缓存请求回来的值
			this.cacheData = JSON.parse(JSON.stringify(response));
			this.setColumnsData();
			this.setHistoryFormData(response);
			this.loading = false;
		}).catch((error) => {
			if(error.error == "获取历史请求较多，请等待"){
				setTimeout(()=>{
					this.getHistorydata(data,i);
				},1000)
			}else{
				this.$Message.error("数据请求错误！");
				this.loading = false;
			}
		});
	},
	
    apiData() {
      return new Promise((resolve) => {
        // 用来存储查询格式的点数据
        this.newNameList = [];
        if (data != null) {
          data.name.forEach((item) => {
            var arr = item.split(".");
            arr.length = arr.length - 1;
            this.newNameList.push(arr.join("."));
          });
        }
        resolve("success");
      });
    },
    /*
          参数： name 导出文件的名称
          作用：文件导出
      */
    ExportFile(name) {
      if (name == "") {
        name = "historyReport";
      }
      if (this.temporaryData.length != 0) {
        this.$refs.historyTable.exportCsv({
          filename: name,
          columns: this.columns,
          data: this.temporaryData,
        });
      } else {
        this.$Message.error("暂无数据可以进行导出");
      }
    },
    /*
          参数： 无
          作用：文件打印
      */
    Print() {
      if (this.nav()) {
        this.$Message.warning("手机以及ipad不支持表单打印!");
      } else {
        this.$Spin.show();
        var columnName = [];
        if (this.jsonData == undefined) {
          this.$Message.warning("无数据！打印失败！");
          this.$Spin.hide();
          return;
        }
        // for (var k in this.jsonData[0]) {
        //   columnName.push(k);
        // }
        for (var k in this.columns) {
          columnName.push(this.columns[k].title);
        }
        if(columnName[0]==" "){
          columnName.shift();
        }
        for (var k in this.jsonData) {
            for(var o in this.columns){
              this.jsonData[k][this.columns[o].title] = this.jsonData[k][this.columns[o].key];
            }
        }
        Print({
          printable: this.jsonData,
          properties: columnName,
          type: "json",
          onLoadingEnd: () => {
            this.$Spin.hide();
          },
        });
      }
    },
    /* ---------------------------------------------脚本在上--------------------------------------------------*/
    /* ---------------------------------------------方法在下--------------------------------------------------*/
    /*
          参数：无
          作用：控制class样式绑定为变量
      */
    func() {
      // var textColor = this.tableTextColor?this.tableTextColor:"#000";
      // 改变表单字体颜色为用户配置
      var n = 0;
      this.isTransparent ? (n = 0.2) : (n = 1);
      //奇数
      this.$refs.hisReport.style.setProperty(
        "--oddColor",
        this.historyFormData.length != 0
          ? this.colorRgba(this.oddColor, n)
          : this.colorRgba("#f8f8f9", n)
      );
      //字体颜色
      this.$refs.hisReport.style.setProperty("--fontColor", this.fontColor);
      //偶数
      this.$refs.hisReport.style.setProperty(
        "--evenColor",
        this.colorRgba(this.evenColor, n)
      );
      //背景色
      this.$refs.hisReport.style.setProperty(
        "--thColor",
        this.colorRgba(this.tableBackgroundColor, n)
      );
      //字体颜色
      // this.$refs.hisReport.style.setProperty("--tableTextColor",textColor);
      //是否开启透明色
      this.$refs.hisReport.style.setProperty(
        "--bgColor",
        this.isTransparent
          ? "transparent"
          : this.colorRgba(this.tableBackgroundColor, n)
      );
      // this.borderColor = "#f10909"
      this.$refs.hisReport.style.setProperty("--borderColor", this.borderColor);
      var rowHeight = this.page.rowHeight ?this.page.rowHeight : 30
      this.$refs.hisReport.style.setProperty("--trHeight", rowHeight+"px");
    },
    doFixedEvent() {},
    /*
          参数：data 为需要转化的数据
          作用：更新历史表单varList的数据格式转化
      */
    conversionData(data) {
      return new Promise((resolve) => {
        // 用来存储查询格式的点数据
        this.newNameList = [];
        if (data != null) {
          data.name.forEach((item) => {
            var arr = item.split(".");
            arr.length = arr.length - 1;
            this.newNameList.push(arr.join("."));
          });
        }
        resolve("success");
      });
    },
    /*
          参数：无
          作用：设置表单表头数据
      */
    setColumnsData() {
      this.datalayout = [
        {
          title: this.fvSystemApi.getResource("采样时间") || "采样时间",
          key: "time",
          align: "center",
          width: this.tableColWidth,
          resizable :true
        },
      ];
      if (!this.page.displayTime) {
        this.datalayout.splice(0, 1);
        this.datalayout.push({
          title: " ",
          key: "calculate",
          align: "center",
          width: this.tableColWidth,
          resizable :true
        });
      }
      if (this.page.data != null) {
        var disposeData = JSON.parse(JSON.stringify(this.page.data.name));
        for (var i = 0; i < this.page.data.name.length; i++) {
          this.datalayout.push({
            title:
              this.fvSystemApi.getResource(this.page.data.desc[i]) ||
              this.page.data.desc[i] ||
              this.fvSystemApi.getResource(this.newNameList[i]) ||
              this.newNameList[i],
            key: this.newNameList[i],
            align: "center",
            width: this.tableColWidth,
            resizable :true
          });
        }
      }
      this.columns = this.datalayout;
      
      // 计算字符宽度
      let canvas = document.createElement("canvas");
      canvas.style.positon = "ablsolute";
      let ctx = canvas.getContext("2d");

      let domWidth = parseInt(this.domStyle.width);
      // 计算数据长度值
      let countNum = 0;
      this.columns.map((item) => {
        let maxWidth = this.getCharSizeByCanvas(
          item.title.toString(),
          canvas,
          ctx
        );
        // 计算累计值
        countNum += maxWidth + 50;
        // 给表头赋值宽度
        item.width = maxWidth + 50;
      });
      // 如果数据累加的值没有容器本身宽，那么就自适应，如果超过了，那么就按照原来的方式显示
      if (countNum < domWidth) {
        if(this.page.columnWidth){
          this.columns.map((item, index) => {
              item.width = this.page.columnWidth;
            
          });
        }else{
          var difference = (domWidth - countNum) / this.columns.length;
          this.columns.map((item, index) => {
              item.width += difference;
            
          
        });
        }
        
      }
    },
    dblclickrow(data,index){
        var list=document.getElementsByClassName('ivu-table-row');
		    var h = list[0].clientHeight;
        var t = 0;
        for(var i =0;i<list.length;i++){
            if(list[0].childNodes[list[i].childNodes.length-1].nodeName != "DIV"){
                list[i].innerHTML+= "<div class='move' style='border-bottom: 0px dashed rgba(0, 0, 0, 0.65);position: absolute;left: 1px;top:"+t+"px;height:"+h+"px;float: left;width: 100px;cursor: row-resize;z-index: 1;'></div>";
            }
        }
        var move=document.getElementsByClassName('move');
        for(var q =0;q<move.length;q++){
            //鼠标按下
            move[q].onmousedown=function(e,q){
                this.domNode= e;
                this.domY = e.y;//当前点击的y
                this.domParentNode = e.toElement.parentNode;// 节点tr
                this.downKey = true;//标记按下了
                this.top = parseFloat(e.toElement.style.top);//当前图元原始top
                this.hg= this.domParentNode.clientHeight;//节点tr的原始高度
                for(var a =0;a<move.length;a++){
                    move[a].style.display="none";
                }
                e.toElement.style.display="block";
                e.toElement.style.top= this.top+"px"
                if(parseFloat(e.toElement.style.top)<0){
                    e.toElement.style.top = "0px";
                }else{
                    e.toElement.style.top = this.top+this.prentY+"px";
                }
                this.domNode.toElement.style.borderBottomWidth="0px";
                e.toElement.style.height="100px";
                e.toElement.style.borderBottomWidth="1px"
            }.bind(this)
            //鼠标抬起
            move[q].onmouseup=function(e){
                this.downKey = false;
                for(var a =0;a<move.length;a++){
                    move[a].style.display="block";
                }
                e.toElement.style.height=h+"px";
                // e.toElement.style.top = this.hg+this.prentY-(h/2)+"px"
                e.toElement.style.borderBottomWidth="0px";
                e.preventDefault()
            }.bind(this)
            //鼠标移动
            move[q].onmousemove=function(e){
                if(this.downKey == true){
                    this.prentY = e.y -this.domY;
                    if(this.hg+this.prentY>=30){
                        //div跟随鼠标
                        if(parseFloat(e.toElement.style.top)<0){
                           e.toElement.style.top = "0px";
                        }else{
                           e.toElement.style.top = this.top+this.prentY+"px";
                        }
                       
                        //同时计算移动像素加到高度上
                        this.domParentNode.style.height = this.hg+this.prentY+"px";
                    }
                }
                e.preventDefault()
            }.bind(this)
        }
    },
    insertAfter( newElement, targetElement ){ // newElement是要追加的元素 targetElement 是指定元素的位置
        var parent = targetElement[0].parentNode; // 找到指定元素的父节点
        if( parent.lastChild == targetElement ){ // 判断指定元素的是否是节点中的最后一个位置 如果是的话就直接使用appendChild方法
          parent.appendChild( newElement, targetElement );
        }else{
          parent.insertBefore( newElement, targetElement.nextSibling );
        };
    },
    // 计算文字长度
    getCharSizeByCanvas(char, canvas, ctx, style = {}) {
      let { fontSize = 14, fontFamily = "Arial" } = style;
      document.body.appendChild(canvas);
      ctx.font = `${fontSize}px ${fontFamily}`;
      document.body.removeChild(canvas);
      let text = ctx.measureText(char); // TextMetrics object
      ctx.fillText(char, 50, 50);
      return text.width;
    },
    /*
          参数：data 请求的历史数据
          作用：设置表单数据
      */
    setHistoryFormData(data) {
      //临时数据
      // var errorArray = [];
      if (data.varList.length >= 1) {
        data.varList.forEach((item) => {
          var startTime = new Date(this.page.startTime).getTime();
          var intervalTime = this.page.intervalTime;
          item.valueList.forEach((list) => {
            if (list.PV != undefined && list.PV != -9999) {
              list.TIME = list.TIME
                ? list.TIME
                : (startTime += intervalTime * 1000);
              this.setTemporaryData.push(list);
            } else {
              list.TIME = list.TIME
                ? list.TIME
                : (startTime += intervalTime * 1000);
              list.PV = "--";
              list.NAME = item.varName;
              this.setTemporaryData.push(list);
              // errorArray.push(list.NAME);
            }
          });
        });
      }
      // this.errorPoint = Array.from(new Set(errorArray));
      this.disposeData(this.setTemporaryData);
     
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "/";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "/";
      var D =
        date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
      var h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      var m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    /*
          参数：data 需要处理的数据
          作用：处理数据为展示运用    
      */
    disposeData(data) {
      this.temporaryData = [];
      if (data.length >= 1) {
        data.forEach((item) => {
          item.NAME = this.resolveName(item.NAME);
          item.time = this.timestampToTime(item.TIME);

          item.TIME = new Date(item.TIME).format("yyyy/MM/dd hh:mm:ss");
          //目前只考虑数据为number类型
          if (typeof item.PV == "number") {
            item.PV = item.PV.toFixed(this.page.effectiveNum);
          } else {
            item.PV = item.PV + "";
          }
        });
        var map = {};
        for (var i = 0; i < data.length; i++) {
          var ai = data[i];
          if (!map[ai.time]) {
            var a = {};
            a.time = ai.time;
            a[ai.NAME] = ai.PV;
            map[ai.time] = a;
          } else {
            map[ai.time][ai.NAME] = ai.PV;
          }
        }
        for (var k in map) {
          this.temporaryData.push(map[k]);
        }
        // 将错误的点以 -- 形式加入列表中
        // this.temporaryData.forEach(list => {
        //   this.errorPoint.forEach(lists => {
        //     list[lists] = "- -";
        //   });
        // });
        //是否展示最大最小平均值
        this.showCalculate(this.temporaryData);
      }
      if (this.tableHeight == 0) {
        var page = Math.floor((this.height - 31.89) / 40);
      } else {
        var page = Math.floor((this.tableHeight - 31.89) / 40);
      }
      this.pageSize = this.pagination ? this.pagination : page > 1 ? page : 1;
      if(this.page.rowNumber){
        this.pageSize = this.page.rowNumber ? this.page.rowNumber:this.pageSize;
      }
      //this.arrOpts[0]=this.pageSize;
      this.changepage(this.currentPage);
    },
    /*
          参数：data 需要刷新的数据
          作用：刷新数据至表单上  刷新数据
      */
    refreshHistoryForm(data) {
      this.historyFormData = [];
      //强制刷新
      this.$nextTick(() => {
          data.forEach(item=>{
                this.historyFormData.push(item)
          })
      })
      // 为打印提供json数据
      this.jsonData = JSON.parse(JSON.stringify(this.temporaryData));
      this.disposePrintData(this.jsonData);
        setTimeout(()=>{
            this.dblclickrow();
        },2000)

    },
    /*
          参数：data 刷新至表单的数据
          作用：为数据添加用户所选择的 最大最小平均值
      */
    showCalculate(data) {
      if (this.cacheData.varList.length != 0) {
        var max = {};
        var min = {};
        var average = {};
        if (this.page.displayTime) {
          max.time = this.fvSystemApi.getResource("最大值") || "最大值";

          min.time = this.fvSystemApi.getResource("最小值") || "最小值";

          average.time = this.fvSystemApi.getResource("平均值") || "平均值";
        } else {
          max.calculate = this.fvSystemApi.getResource("最大值") || "最大值";

          min.calculate = this.fvSystemApi.getResource("最小值") || "最小值";

          average.calculate =
            this.fvSystemApi.getResource("平均值") || "平均值";
        }
        this.cacheData.varList.forEach((el) => {
          el.varName = this.resolveName(el.varName);
        });
        this.cacheData.varList.forEach((item) => {
          // 目前只支持类型为number的计算最大最小平均值
          if (
            typeof item.valueList[0].PV == "number" &&
            item.valueList[0].PV != -9999
          ) {
            var maxNum = Math.max.apply(
              Math,
              item.valueList.map(function (o) {
                if (isNaN(o.PV)) {
                  return -100000000;
                } else {
                  return o.PV;
                }
              })
            );
            var minNum = Math.min.apply(
              Math,
              item.valueList.map(function (o) {
                if (isNaN(o.PV)) {
                  return 100000000;
                } else {
                  return o.PV;
                }
              })
            );

            max[item.varName] = maxNum.toFixed(this.page.effectiveNum);
            min[item.varName] = minNum.toFixed(this.page.effectiveNum);
            var sum = 0;
            item.valueList.forEach((list) => {
              if (list.NAME == list.NAME) {
                if (isNaN(list.PV)) {
                  sum += 0;
                } else {
                  sum += list.PV;
                }
              }
            });
            var averageNum = sum / item.valueList.length;
            average[item.varName] = averageNum.toFixed(this.page.effectiveNum);
          } else {
            max[item.varName] = "- -";
            min[item.varName] = "- -";
            average[item.varName] = "- -";
          }
        });
      }
      if (this.page.statisticStyle != null) {
        if (this.page.statisticStyle.indexOf("max") != -1) {
          data.push(max);
        }
        if (this.page.statisticStyle.indexOf("min") != -1) {
          data.push(min);
        }
        if (this.page.statisticStyle.indexOf("average") != -1) {
          data.push(average);
        }
      }
      return data;
    },
    /*
          参数：index 当前页数
          作用：切换分页
      */
    changepage(index) {
      if (this.temporaryData != undefined) {
        this.currentPage = index;
        this.dataCount = this.temporaryData.length;
        var _start = (index - 1) * this.pageSize;
        var _end = index * this.pageSize;
        var data = this.temporaryData.slice(_start, _end);
        this.refreshHistoryForm(data);
      }
    },
    /*
          参数：显示多少条
          作用：切换现实多少条
      */
    changepageSize(index){
      this.pageSize = index;
      this.changepage(1);
    },
    /*
          参数:data 点名
          作用：数据转换为相应的key
      */
    resolveName(data) {
      var str = data;
      var headStr = data.substr(0, 1);
      if (headStr == "/" || headStr == "\\") {
        str = data.slice(1, data.length);
      }
      return str.replace(/\\/g, ".");
    },
    /*
          参数：无
          作用：判断是否支持导出的设备
      */
    nav() {
      var ua = navigator.userAgent;
      var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = isIphone || isAndroid;
      if (isIphone || isAndroid || isMobile) {
        return true;
      } else {
        return false;
      }
    },
    /*
          参数： data 将表单数据转为json数据
          作用： 将数据转为打印形式
      */
    disposePrintData(data) {
      data.forEach((item) => {
        for (var k in item) {
          // var key = k.replace(/\./g, "-");
          // item[key] = item[k];
          // if (k.indexOf(".") != -1) {
          //   delete item[k];
          // }
          // 处理隐藏时间列表但仍需要打印最大最小平均值的问题
          if (k == "calculate") {
            item["time"] = item["calculate"];
          }
        }
      });
    },
    /*
          参数：str 十六位制颜色 n 透明度
          作用：将十六位制的颜色转为rgba
      */
    colorRgba(str, n) {
      if (!str) return;
      //十六进制颜色值的正则表达式
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      var sColor = str.toLowerCase();
      //十六进制颜色转换为RGB格式
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          var sColorNew = "#";
          for (var i = 1; i < 4; i += 1) {
            //例如：#eee,#fff等
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        //处理六位颜色值
        var sColorChange = [];
        for (var i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }
        return "rgba(" + sColorChange.join(",") + "," + n + ")";
      } else {
        return sColor;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/primitives/fvHistoryReport/fvHistoryReport.vue